import { useMutation, useQueryClient } from '@tanstack/react-query';
import { createTodoTaskAction } from '../actions/createTodoTask.action';
import { FlowTask } from '../interfaces/flowTask.interface';
import { useAppDispatch } from '../../../redux/hooks/redux';
import { fetchBenefits } from '../../../permissions/benefits/redux/benefits.thunks';

export const useCreateTodoTask = () => {
  const queryClient = useQueryClient();
  const dispatch = useAppDispatch();

  return useMutation({
    mutationFn: (task: Omit<FlowTask, 'uid' | 'createdAt' | 'updatedAt'>) =>
      createTodoTaskAction(task),
    onSuccess: (newTask) => {
      // Invalidate and refetch tasks for the kanban page
      dispatch(fetchBenefits());
      queryClient.invalidateQueries({
        queryKey: ['todo-tasks'],
      });
    },
  });
};

